import { createReducer, on, Action } from '@ngrx/store';
import * as TeamTypeActions from './team-types.actions';
import { TeamType } from '@/models/team-type.model';

export interface TeamTypesState {
  teamTypes: TeamType[];
  loading: boolean;
  error: any | null;
  createSuccess: boolean;
  updateSuccess: boolean;
}

export const initialState: TeamTypesState = {
  teamTypes: [],
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
};

const _teamTypeReducer = createReducer(
  initialState,
  on(TeamTypeActions.loadTeamTypes, (state) => ({ ...state, loading: true, error: null })),
  on(TeamTypeActions.loadTeamTypesSuccess, (state, { teamTypes }) => ({
    ...state,
    teamTypes: teamTypes,
    loading: false,
  })),
  on(TeamTypeActions.loadTeamTypesFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(TeamTypeActions.createTeamType, (state) => ({ ...state, loading: true, error: null, createSuccess: false })),
  on(TeamTypeActions.createTeamTypeSuccess, (state, { teamType }) => ({
    ...state,
    teamTypes: [...state.teamTypes, teamType],
    loading: false,
    createSuccess: true,
  })),
  on(TeamTypeActions.createTeamTypeFailure, (state, { error }) => ({ ...state, loading: false, error, createSuccess: false })),
  on(TeamTypeActions.resetCreateTeamTypeStatus, (state) => ({ ...state, createSuccess: false })),

  on(TeamTypeActions.updateTeamType, (state) => ({ ...state, loading: true, error: null, updateSuccess: false })),
  on(TeamTypeActions.updateTeamTypeSuccess, (state, { teamType }) => ({
    ...state,
    teamTypes: state.teamTypes.map((tt) => (tt.id === teamType.id ? teamType : tt)),
    loading: false,
    updateSuccess: true,
  })),
  on(TeamTypeActions.updateTeamTypeFailure, (state, { error }) => ({ ...state, loading: false, error, updateSuccess: false })),
  on(TeamTypeActions.resetUpdateTeamTypeStatus, (state) => ({ ...state, updateSuccess: false }))
);

export function teamTypeReducer(state: TeamTypesState | undefined, action: Action) {
  return _teamTypeReducer(state, action);
}

// Manual selectors
export const selectAllTeamTypesData = (state: TeamTypesState) => state.teamTypes;
export const selectTeamTypeByIdData = (id: number) => (state: TeamTypesState) => state.teamTypes.find((tt) => tt.id === id);

export const selectTeamTypesLoading = (state: TeamTypesState) => state.loading;
export const selectTeamTypesError = (state: TeamTypesState) => state.error;
export const selectCreateTeamTypeSuccess = (state: TeamTypesState) => state.createSuccess;
export const selectUpdateTeamTypeSuccess = (state: TeamTypesState) => state.updateSuccess;
